import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * Configures which RBAC role(s) are looped in (Layer 1 — recipient routing)
 * when an Issue of a given "category" is created or updated. HOW each resolved
 * recipient is reached (in-app bell / email / push), and whether they opt out
 * entirely, is Layer 2 — the per-user `user_notification_preference` applied at
 * the `NotificationDispatchService` choke point, which drops or re-routes
 * channels but never adds a recipient Layer 1 didn't resolve. See
 * docs/claude/notifications/issue-routing-composition.md.
 *
 * The category axis is the issue's LINKED-ENTITY type
 * (issue_link.entity_type) — e.g. 'vehicle', 'client' — or the literal
 * 'general' for issues that have no linked entity (see
 * ISSUE_NOTIFICATION_GENERAL_CATEGORY). One row per (category, role).
 *
 * Resolution (IssueNotificationConfig.getRecipients): for an issue's
 * applicable categories, gather the configured roles, resolve each role to
 * its active users, and add their emails to the recipients — de-duped with
 * assignee / watchers / client salesperson.
 */
@Index('UK_issue_notification_role_config', ['category', 'fkRbacRoleId'], {
	unique: true,
})
@Index('idx_issue_notification_role_config_category', ['category'], {})
@Entity('issue_notification_role_config')
export class IssueNotificationRoleConfigEntity extends BaseEntity {
	// A LinkableEntityType value (e.g. 'vehicle', 'client') or 'general'.
	@Column('varchar', { name: 'category', length: 50 })
	public category!: string;

	// FK to _rbac_role._id — the role whose active users get notified.
	@Column('int', { name: 'fk__rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;
}
